import formatUser from './formatUser';

const formatPost = (post) => ({
  objectId: post.id,
  user: formatUser(post.author || {}),
  classRoom: post.space,
  content: post.content,
  important: post.important,
  createdAt: post.createdAt,
  editedAt: post.editedAt,
  deletedAt: post.deletedAt,
  scheduledFor: post.scheduledFor,
  publishedAt: post.publishedAt,
  tags: post.tags || [],
});

export default formatPost;
